// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"ov_a bic_a bic_x","FilterForm__vgroup":"ov_b bic_sv"};